/**
 * Guarda de rota da suíte (SPEC-v2 2.1): envolve tudo menos `SUI-01`–`SUI-05` e `/tv`. Sem sessão
 * → `/entrar?volta=<rota>` (só caminho interno) ou `/configurar` quando o navegador ainda não tem
 * dono. Enquanto a sessão abre, a tela de abertura estática continua na tela.
 */
import { type ReactNode, useEffect } from 'react';
import { Redirect, useLocation, useSearch } from 'wouter';
import { useSessionState } from '@/data/auth/session';
import { bootstrapSession } from './session';

export function AuthGate({ children }: { children: ReactNode }) {
  const st = useSessionState();
  const [location] = useLocation();
  const search = useSearch();
  useEffect(() => {
    if (st.status === 'unknown') void bootstrapSession();
  }, [st.status]);
  if (st.status === 'signed_in') return <>{children}</>;
  if (st.status === 'signed_out') {
    if (st.needsSetup) return <Redirect to="~/configurar" replace />;
    const here = `${location}${search ? `?${search}` : ''}`;
    const volta = here === '/' ? '' : `?volta=${encodeURIComponent(here)}`;
    return <Redirect to={`~/entrar${volta}`} replace />;
  }
  return null;
}
